import { app, Component } from 'apprun';
import AgCharts from './template/chart-template';
import { lang } from './Txlat';
const Chart = window['Chart'];

const options = {
  cutoutPercentage: 60,
  responsive: false,
  tooltips: false,
},
  backgroundColor = [
    'rgba(255, 99, 132, 0.5)',
    'rgba(54, 162, 235, 0.5)',
    'rgba(255, 206, 86, 0.5)',
    'rgba(75, 192, 192, 0.5)'
  ],
  borderColor = [
    'rgba(255 ,99, 132, 1)',
    'rgba(54, 162, 235, 1)',
    'rgba(255, 206, 86, 1)',
    'rgba(75, 192, 192, 1)'
  ];

export default class Charts extends Component {
  view = (state) => {
    return (
      <AgCharts chartData_type={state.chartData_type} chartData_status={state.chartData_status} chartData_city={state.chartData_city} />
    );
  };
  update = {
    '/setComponentState': async (state, { properties }) => {
      const chartData_type = [];
      const chartData_status = [];
      const chartData_city = [];

      const property_types = [... new Set(properties.map(l => l.property_type))];
      const property_status = [... new Set(properties.map(l => l.status))];
      const property_cities = [... new Set(properties.map(l => l.city))];

      const types_data = [];
      property_types.forEach((name) => {
        if (name) {
          if (lang.get() === 'fr') {
            const type_ratio = (properties.filter(p => p.property_type && p.property_type[1] === name[1]).length / properties.length) * 100;
            types_data.push(type_ratio);
            if (chartData_type.filter(c => c.name === name[1]).length === 0) { chartData_type.push({ name: name[1], type_ratio }); }
          } else {
            const type_ratio = (properties.filter(p => p.property_type && p.property_type[0] === name[0]).length / properties.length) * 100;
            types_data.push(type_ratio);
            if (chartData_type.filter(c => c.name === name[0]).length === 0) { chartData_type.push({ name: name[0], type_ratio }); }
          }
        }

      });
      const status_data = [];
      property_status.forEach((name) => {
        const status_ratio = (properties.filter(p => p.status === name).length / properties.length) * 100;
        status_data.push(status_ratio);
        chartData_status.push({ name, status_ratio });
      });
      const city_data = [];
      property_cities.forEach((name) => {
        const city_ratio = (properties.filter(p => p.city === name).length / properties.length) * 100;
        city_data.push(city_ratio);
        chartData_city.push({ name, city_ratio });
      });
      return {
        chartData_type, chartData_status, chartData_city,
        types_data, status_data, city_data
      };
    }
  };

  rendered = ({ types_data, status_data, city_data }) => {

    if (types_data) {
      const chartData = types_data;
      const ctx = (document.getElementById('agent-stats-property-types') as HTMLCanvasElement).getContext('2d');
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [{
            data: chartData,
            backgroundColor,
            borderColor,
            borderWidth: 1
          }]
        },
        options
      });
    }

    if (status_data) {
      const chartData = status_data;
      const ctx = (document.getElementById('stats-property-status') as HTMLCanvasElement).getContext('2d');
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [{
            data: chartData,
            backgroundColor,
            borderColor,
            borderWidth: 1
          }]
        },
        options
      });
    }

    if (city_data) {
      const chartData = city_data;
      const ctx = (document.getElementById('stats-property-cities') as HTMLCanvasElement).getContext('2d');
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [{
            data: chartData,
            backgroundColor,
            borderColor,
            borderWidth: 1
          }]
        },
        options
      });
    }
  };
}
